import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { logout } from '../../store/slices/authSlice';
import './Header.css';

const Header = ({ children }) => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);

  const handleLogout = () => {
    dispatch(logout());
  };

  return (
    <header className="header">
      <div className="header-content">
        <div style={{ display:'flex', alignItems:'center', gap:'12px' }}>
          {children}
          <h1 className="header-title">B2B Marketplace</h1>
        </div>
        <div className="header-actions">
          <span className="user-info">
            {user?.companyName} ({user?.accountType})
          </span>
            <button onClick={handleLogout} className="logout-btn">Logout</button>
        </div>
      </div>
    </header>
  );
};

export default Header;